import React, { useMemo } from "react";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";

export default function MonthTable({ complaintsPaTableStateFilterData }) {
  const data = useMemo(() => {
    const mapped =
      complaintsPaTableStateFilterData?.map((item) => ({
        division: item.key,
        complaintCount: item.doc_count,
      })) || [];
    return mapped;
  }, [complaintsPaTableStateFilterData]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "division",
        header: "Problem Area",
        cell: (info) => info.getValue(),
      },
      {
        accessorKey: "complaintCount",
        header: "Complaint Count",
        cell: (info) => info.getValue(),
      },
    ],
    []
  );

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className="border rounded overflow-hidden">
      <div className="max-h-[315px] overflow-y-auto">
        <table className="w-full border text-sm table-fixed text-center">
          <thead className="bg-gray-100 sticky top-0 z-10">
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    className="border px-3 py-2 font-medium bg-gray-100 text-center"
                  >
                    {flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {data.length > 0 ? (
              table.getRowModel().rows.map((row, rowIndex) => (
                <tr
                  key={row.id}
                  className={rowIndex % 2 === 0 ? "bg-white" : "bg-gray-50"}
                >
                  {row.getVisibleCells().map((cell) => {
                    const value = cell.getValue()?.toString() || "";
                    return (
                      <td
                        key={cell.id}
                        className="border px-3 py-2 truncate text-center"
                        title={value}
                      >
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={columns.length}
                  className="border px-3 py-2 text-center text-gray-500"
                >
                  No complaints data available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
